import React from 'react';
import styles from './TabBar.module.css';

export interface TabItem {
  key: string;
  label: string;
}

interface TabBarProps {
  tabs: readonly TabItem[] | TabItem[];
  activeKey: string;
  onTabChange: (key: string) => void;
  variant?: 'default' | 'pill';
  actions?: React.ReactNode;
  className?: string;
}

const TabBar: React.FC<TabBarProps> = ({
  tabs,
  activeKey,
  onTabChange,
  variant = 'default',
  actions,
  className = '',
}) => {
  const barCls = [
    variant === 'pill' ? styles.tabBarPill : styles.tabBar,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={barCls}>
      <div className={styles.tabList}>
        {tabs.map((tab) => {
          const isActive = tab.key === activeKey;
          return (
            <button
              key={tab.key}
              className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
              onClick={() => onTabChange(tab.key)}
              type="button"
            >
              {tab.label}
              {isActive && <span className={styles.tabIndicator} />}
            </button>
          );
        })}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

export default TabBar;
